import React from "react";
import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import {
  ArrowDownTrayIcon,
  ArrowLeftIcon
} from "@heroicons/react/24/outline";

/* ------------------------------------------------------------
   Adatszerkezet – slug → { title, type, parts }
     type = "text"       → parts: { body }
     type = "pdf"        → parts: { file }
     type = "gallery"    → parts: { body, images: [src] }
------------------------------------------------------------ */

const grants = [
  {
    slug: "vca-2021-002254",
    title:
      "A Városi Civil Alap keretében 2021. évben meghirdetett ‘civil közösségi tevékenységek és feltételeinek támogatása’ – VCA-KP-1-2021/3-002254",
    type: "text",
    parts: {
      body:
        "Az elnyert pályázati összegből 3 millió Ft értékben varrattunk 10 rend férfi kalotaszegi viseletet, azaz 10 db bőujjú hímzett mérai inget, 10 db bricses nadrágot, 10 db mellényt és 5 db díszes bujkát. Valamint női kalotaszegi viseletekből elkészülhetett egyesületünk részére 10 db szoknya, 8 db pántlikás kötény és 5 db díszes mellény.",
    },
  },
  {
    slug: "top-2021-02410",
    title:
      "Balaton Tánc Egyesület civil ház felszereléséhez kapcsolódó eszközbeszerzése – TOP‑7.1.1‑16‑H‑ERFA‑2021-02410",
    type: "pdf",
    parts: { file: "top-2021-02410.pdf" },
  },
  {
    slug: "top-2021-00923",
    title:
      "Balaton Tánc Egyesület civil ház felszereléséhez kapcsolódó eszközbeszerzése – TOP‑7.1.1‑16‑H‑ERFA‑2021‑00923",
    type: "pdf",
    parts: { file: "top_2021_00923.pdf" },
  },
  {
    slug: "csoori-2022-2023",
    title: "Csóri pályázat 2022-2023.",
    type: "gallery",
    parts: {
      body:`A 2022-es táncház pályázaton nyert támogatást négy korosztály: aprók, gyermek, tini és felnőtt táncház tartására fordítottuk. A közös táncolás, éneklés segítségével próbáltuk a különböző generációkat közel hozni egymáshoz. A nagy létszámmal látogatott apropók táncház minden hónap első szombatján került megszervezésre, két alkalommal tiniknek, egy alkalommal gyermekeknek, négyszer felnőtteknek volt korosztályos táncház.

A táncházak megvalósításában Angyal Marianna, Fodor Janka Papp Károly volt segítségünkre. Zenét szolgáltatott a Sólya zenekar, Deáky Márton és barátai, valamint a Tarsoly zenekar.

A pályázati ciklus lehetőséget biztosított az együttes számára, hogy elvárásainak megfelelően elkezdje felkészülését a 60 éves jubileumi évre. A nyári szezonban edzőtáborban voltak a táncosok. A női tánckar tagjainak Strack Orsolya moldvai táncokat tanított, a férfi tánckarnak Sikentáncz Szilveszter györgyfalvi koreográfiát tanított be. Ez a két koreográfia az immáron hagyományosnak mondható táncszínházi előadásunk keretében került bemutatásra, mely ebben az évben a „Szilánkok” elnevezést kapta. Két alkalommal táncolhattunk telt ház előtt. A neves vendégoktatók tiszteletdíja mellett a pályázatban elnyert összegből a viselettárunkat is bővíteni tudtuk, parasztingeket, moldvai viseleteket, egy székely viseletet, valamint somogyi kötényeket vásároltunk, ez hozzájárult együttesünk színvonalas működésének továbbfejlődéséhez.

CSSP-TANCHAZ-2022-0211

CSSP-NEPTANC-MO-2022-0307`,
      images: [
        "/gallery/csoori22_01.jpg",
        "/gallery/csoori22_02.jpg",
        "/gallery/csoori22_03.jpg",
        "/gallery/csoori22_04.jpg",
        "/gallery/csoori22_05.jpg",
        "/gallery/csoori22_06.jpg",
        "/gallery/csoori22_07.jpg",
        "/gallery/csoori22_08.jpg",
        "/gallery/csoori22_09.jpg",
        "/gallery/csoori22_10.jpg",
      ],
    },
  },
  {
    slug: "csoori-2021",
    title: "Csóri Sándor Program 2021",
    type: "gallery",
    parts: {
      body:`A 2021-es táncházas keretet tini, felnőtt és többgenerációs táncházak és tánctanítások szervezésére fordítottuk, elsősorban a néptáncot és népzenét kedvelő ifjúsági és felnőtt korosztály számára. Célunk volt, hogy a pandémiát követően még jobban kiszélesedő generációs szakadékokat átíveljük, a korosztályokat közelebb hozzuk egymáshoz a táncház nyújtotta közös táncolás, éneklés által.

Ezeket a táncházakat augusztusra szerveztük, minden hétvégére egyet, hogy a nyári tanítási szünet alatt se szenvedjen senki hiányt a néptánc és népzene nyújtotta élményekből. Két tini és két felnőtt táncház valósult meg ezeken a hétvégéken.

A tini táncházakon a siófoki Művészeti Iskola néptánctagozatának növendékei vettek részt a családtagok és barátok kíséretében, ahol nagyrészt somogyi és szilágysági táncanyagot gyakorolhattak a résztvevők.

A felnőtt táncházakat a Balaton Táncegyüttes aktív táncosai és hozzátartozóik látogatták elsősorban. Itt a palatkai, bukovinai és györgyfalvi táncok rejtelmeibe vetettük bele magunkat.

Vendégoktatónk Sikentáncz Szilveszter volt, a talpalávaló muzsikát pedig a Tarsoly zenekar tagjai (Jobbágy Bence, Böröcz Balázs, Blaskó Norbert, Hornich Thomas, Bencze Mátyás) szolgáltatták a táncházak alkalmával. Az év végét pedig egy összevont közös egész estés táncházzal zártuk szintén a Tarsoly zenekar közreműködésével. Itt az egész 2022-es év táncanyagait sorra vettük, amelyekkel komolyabban foglalkoztunk: somogyi, szilágysági, ipolymenti, moldvai, bukovinai, palatkai, györgyfalvi.

A pályázati ciklus két legfontosabb eredménye az “Önök színe előtt bátran megállottam” című táncszínházi előadásunk megvalósulása, illetve a Szekszárdi Néptáncfesztivál sikerei. Előbbi esetében a terveink szerint méltó képpen emlékezhettünk egyik alapítónk, Együd Árpád szellemisége előtt. Mind két előadásunkat telt ház előtt táncolhattuk el, mely táncosainknak életre szóló élményeket nyújtottak. Ezen túl a felkészülés alatt technikailag is rengeteget fejlődött együttesük tánckara és lehetőségünk nyílt az eddigi színvonalunkon emelni mind megjelenésben, mind pedig a színpadon nyújtott teljesítményben is egyaránt.

A Szekszárdi Néptáncfesztiválon III. helyezés Kiemelt nívódíjat, valamint Muharay Különdíjat nyert el együttesünk, mely az utóbbi évek legnagyobb szakmai sikerét jelentette műhelyünk számára. A pályázati lehetőségek nélkül ezen terveink nem valósulhattak volna meg.

CSSP-TANCHAZ-2021-0275

CSSP-NEPTANC-MO-2021-0377`,
      images: [
        "/gallery/csoori21_01.jpg",
        "/gallery/csoori21_02.jpg",
        "/gallery/csoori21_03.jpg",
        "/gallery/csoori21_04.jpg",
        "/gallery/csoori21_05.jpg",
        "/gallery/csoori21_06.jpg",
        "/gallery/csoori21_07.jpg",
        "/gallery/csoori21_08.jpg",
        "/gallery/csoori21_09.jpg",
        "/gallery/csoori21_10.jpg",
        "/gallery/csoori21_11.jpg",
        "/gallery/csoori21_12.jpg",
        "/gallery/csoori21_13.jpg",
        "/gallery/csoori21_14.jpeg",
        "/gallery/csoori21_15.jpeg",
        "/gallery/csoori21_16.jpg",
        "/gallery/csoori21_17.jpg",
        "/gallery/csoori21_18.jpg",
      ],
    },
  },
  {
  slug: "csoori-2020",
  title: "Csóri Sándor Program 2020",
  type: "gallery",
  parts: {
    heroImages: [
      "/gallery/cs20_hero1.jpg",
      "/gallery/cs20_hero2.jpg"
    ],
    body: `A 2020-ban elnyert pályázatnak köszönhetően elkezdődtek a Balaton Táncegyüttes alapítója, Együd Árpád emlékműsorának munkálatai. Sikentáncz Szilveszterrel ipolymenti táncokat tanultunk, melyből koreográfia is készült. Horváth Tibor és Zóka Éva zselici táncokat tanított együttesünknek, melyből szintén létrejött egy színpadi koreográfia is. Ezen oktatói és koreográfusi díjak kifizetése nem jöhetett volna létre a pályázatban elnyert támogatás nélkül.
    
Repertoárunk bővítése mellett a támogatási összeg lehetőséget nyújtott művészeti vezetőink megtartására is, hiszen a dologi kiadásokból az említett személyek tiszteletdíját is finanszírozni tudtuk.

A fennmaradó összegből Veszprémbe utazott együttesünk, ahol a Táncháztalálkozó Országszerte című programon vettünk részt. Ezen túl két pár táncosunk és együttesünk művészeti vezetője a Nyár 21 című televíziós műsorba kapott meghívást, melynek útiköltségét szintén a fennmaradó pályázati összegből fedeztük.

Egész estés gyermek táncházat és mesejátékot szerveztünk az együttesünk közvetlen utánpótlását képző művészeti iskolás gyerekeknek, melyet Horti Zoltán vezetett le.

Többgenerációs táncházat és tánctanítást szerveztünk a néptáncot és népzenét kedvelő ifjúsági és felnőtt korosztály számára. Célunk volt, hogy a pandémiát követően még jobban kiszélesedő generációs szakadékokat átíveljük, a korosztályokat közelebb hozzuk egymáshoz a táncház nyújtotta közös táncolás, éneklés által. Ezeken a táncházakon ipolymenti, szilágysági és somogyi táncanyaggal ismerkedhetnek meg a résztvevők helyi és vendégoktatók közreműködésével. Ezen túl tartottunk tematikus táncházakat is, mint például a húsvéti és pünkösdi táncházak, melyeket csapatjátékokkal, vetélkedőkkel, „Nyúlkirály” választással igyekeztünk színesíteni.

A pályázatban elnyert összeg segítségével, a megvalósult programjaink és táncházaink nagyobb teret biztosítottak városunkban a népzene és néptánc hagyományának. Kulturális szórakozási lehetőséget, táncteret biztosítottunk minden korosztály számára és a pandémia okozta károk helyreállításában is kiemelten fontos segítséget nyújtott együttesünk számára.

CSSP-NEPTANC-MO-2020-0377

CSSP-TANCHAZ-2020-0282

A pályázat leírása és a kapcsolódó anyagok az alábbi hivatkozásra kattintva tekinthetők meg:`,
    cta: {
      text: "Csóri Sándor Program 2020",
      href: "https://emet.gov.hu/csoori-sandor-program-2020/"
    },
    images: [
        "/gallery/csoori20_01.jpg",
        "/gallery/csoori20_02.jpg",
        "/gallery/csoori20_03.jpg",
        "/gallery/csoori20_04.jpg",
        "/gallery/csoori20_05.jpg",
        "/gallery/csoori20_06.jpg",
        "/gallery/csoori20_07.jpg",
        "/gallery/csoori20_08.jpg",
        "/gallery/csoori20_09.jpg",
        "/gallery/csoori20_10.jpg",
        "/gallery/csoori20_11.jpg",
        "/gallery/csoori20_12.jpg",
        "/gallery/csoori20_13.jpg",
        "/gallery/csoori20_14.jpg",
        "/gallery/csoori20_15.jpg",
        "/gallery/csoori20_16.jpg",
        "/gallery/csoori20_17.jpg",
        "/gallery/csoori20_18.jpg",
    ]
  }
},
{
  slug: "csoori-2019",
  title: "Csóri Sándor Program 2019",
  type: "gallery",
  parts: {
    heroImages: [
      "/gallery/cs20_hero1.jpg",
      "/gallery/cs20_hero2.jpg"
    ],
    body: `A pályázat nagyban segítette együttesünk működését, hiszen az elnyert összegből fedezni tudtuk az élő népzenei költségeink nagy részét, melynek köszönhetően továbbra is élőzenei kíséret mellett léphettünk színpadra. Ezáltal sikerült megtartani a tőlünk megszokott színvonalat. Ezen túl a művészeti vezetőnk bérének egy részét is meg tudtuk finanszírozni a pályázatban elnyert összegből, mely további anyagi biztonságot adott a táncegyüttesünknek. Ruhatárunk is tovább gyarapodott a pályázatnak köszönhetően 10 db női és 10 db férfi székely viselettel, így a táncosaink gyönyörű, új viseletben léphetnek újra színpadra.

A pályázat leírása és a kapcsolódó anyagok az alábbi hivatkozásra kattintva tekinthetők meg:`,
    cta: {
      text: "Csóri Sándor Program 2019",
      href: "https://emet.gov.hu/csoori-sandor-program-2019/"
    },
    images: [
        "/gallery/csoori19_01.jpeg",
        "/gallery/csoori19_02.jpeg",
        "/gallery/csoori19_03.jpeg",
        "/gallery/csoori19_04.jpeg",
        "/gallery/csoori19_05.jpg",
        "/gallery/csoori19_06.jpg",
        "/gallery/csoori19_07.jpg",
        "/gallery/csoori19_08.jpg",
        "/gallery/csoori19_09.jpg",
        "/gallery/csoori19_10.jpg",
        "/gallery/csoori19_11.jpg",
        "/gallery/csoori19_12.jpg",
        "/gallery/csoori19_13.jpg",
        "/gallery/csoori19_14.jpg",
        "/gallery/csoori19_15.jpg"
    ]
  }
}
];

// ------------------------------------------------------------
// LISTA – /grants
// ------------------------------------------------------------
export function GrantsList() {
  return (
    <main className="mx-auto max-w-5xl px-4 py-16">
      <h1 className="mb-12 text-center text-4xl font-bold">Elnyert pályázatok</h1>
      <div className="grid gap-10 md:grid-cols-2">
        {grants.map((g) => (
            <Link
              key={g.slug}
              to={`/grants/${g.slug}`}
              className="block rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md"
            >
              <p className="text-center font-medium text-gray-700">{g.title}</p>
            </Link>
        ))}
      </div>
    </main>
  );
}

// ------------------------------------------------------------
// VIEWER – /grants/:slug
// ------------------------------------------------------------
export function GrantDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const grant = grants.find((g) => g.slug === slug);

  if (!grant) return <p className="p-10 text-center">Pályázat nem található.</p>;

  const { title, type, parts } = grant;

  return (
    <main className="mx-auto max-w-6xl px-4 py-12">
      <button
        onClick={() => nav(-1)}
        className="mb-6 inline-flex items-center gap-2 text-sm text-primary hover:underline"
      >
        <ArrowLeftIcon className="h-4 w-4" /> Vissza
      </button>

      <h1 className="mb-8 text-center text-3xl font-bold">Elnyert pályázat</h1>
      <h2 className="mb-10 text-center text-2xl font-semibold text-primary max-w-4xl mx-auto">
        {title}
      </h2>

      {type === "text" && (
        <p className="mx-auto max-w-3xl text-center leading-relaxed text-gray-700 whitespace-pre-line">
          {parts.body}
        </p>
      )}

      {type === "pdf" && <PdfViewer file={parts.file} title={title} />}

      {type === "gallery" && (
        <>
        {parts.heroImages && (
            <div className="mx-auto mb-10 grid max-w-3xl gap-6 sm:grid-cols-2">
            {parts.heroImages.map(src => (
                <img key={src} src={src} alt="" className="rounded-lg object-cover" />
            ))}
            </div>
        )}
          <p className="mx-auto mb-10 max-w-3xl text-center leading-relaxed text-gray-700 whitespace-pre-line">
            {parts.body}
          </p>

        {parts.cta && (
            <p className="mb-10 text-center text-lg">
            <a
                href={parts.cta.href}
                className="font-semibold text-primary underline hover:text-primary/80"
                target="_blank"
                rel="noreferrer"
            >
                {parts.cta.text}
            </a>
            </p>
        )}
          <Gallery images={parts.images} />
        </>
      )}
    </main>
  );
}

// PDF iframe
function PdfViewer({ file, title }) {
  const src = `/grants/${file}`;
  return (
    <div>
      <div className="mb-4 text-right">
        <a
          href={src}
          download
          className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90"
        >
          <ArrowDownTrayIcon className="h-5 w-5" /> PDF letöltése
        </a>
      </div>
      <iframe
        src={src + "#toolbar=0"}
        title={title}
        className="h-[80vh] w-full rounded-md border"
      />
    </div>
  );
}

// Egyszerű kép‑rács (Tailwind grid)
function Gallery({ images }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {images.map((src) => (
        <img
          key={src}
          src={src}
          alt="Pályázati kép"
          className="rounded-lg object-cover shadow-sm"
        />
      ))}
    </div>
  );
}

// ------------------------------------------------------------
// Routes wrapper – /grants/*
// ------------------------------------------------------------
export default function GrantsRoutes() {
  return (
    <Routes>
      <Route index element={<GrantsList />} />
      <Route path=":slug" element={<GrantDetail />} />
    </Routes>
  );
}
